import { render, staticRenderFns } from "./ServiceNotificationsBlock.vue?vue&type=template&id=401ea255&scoped=true"
import script from "./ServiceNotificationsBlock.vue?vue&type=script&lang=js"
export * from "./ServiceNotificationsBlock.vue?vue&type=script&lang=js"
import style0 from "./ServiceNotificationsBlock.vue?vue&type=style&index=0&id=401ea255&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401ea255",
  null
  
)

export default component.exports